import { Language } from '@boltenergy-be/shared'

export type FormatCurrencyOptions = {
  maximumFractionDigits?: number
  language?: Language
}

export type FormatAmountOptions = {
  /** Sets both the minimum & maximum amount of fraction digits. Overridden by maxFractionDigits/minFractionDigits. */
  fractionDigits?: number
  maxFractionDigits?: number
  minFractionDigits?: number
}

export enum AddressFormats {
  FULL_SINGLE_LINE = 'fullSingleLine',
  FULL_TWO_LINES = 'fullTwoLines',
  STREET_NUMBER_BOX = 'streetNumberBox',
  POSTAL_CODE_TOWN = 'postalCodeTown'
}
